import { z } from 'zod';
import Unit from '@leverege/unit';
import { Plugins } from '@leverege/plugin';
export default {
  install(plg = Plugins) {
    const unitTypes = Unit.getUnitTypes();
    unitTypes.forEach(unitType => {
      const units = Unit.getUnitsOfType(unitType);
      plg.addPlugin('AttributeValueValidator', {
        valueType: unitType,
        valueValidator: z.object({
          type: z.literal(unitType),
          value: z.number().optional().nullable(),
          unit: z.union(units.map(unit => z.literal(unit.symbol)))
        }).optional().nullable()
      });
    });
  }
};